<template>
  <div class="accordion accordion__submissions">
    <div class="card card-box accordion__submission">
      <div class="card-header submission__header">
        <b-button
          v-b-toggle="`accordion-${learner.id}`"
          class="btn-link btn-lg d-flex align-items-center justify-content-between shadow-none accordion__toggler"
        >
          <div>
            <BaseUserProfile :user-name="learnerFullName">
              <template slot="name">
                <div class="ml-2">
                  <div class="text-dark mb-2">
                    {{ learnerFullName }}
                  </div>
                  <BaseTagSubmissionStatus v-if="status" :status="status" />
                </div>
              </template>
            </BaseUserProfile>
          </div>
          <font-awesome-icon icon="angle-up" class="font-size-xl" />
        </b-button>
      </div>

      <b-collapse
        :id="`accordion-${learner.id}`"
        v-model="showCollapse"
        visible
        accordion="accordion"
        role="tabpanel"
      >
        <div>
          <div class="card__submission">
            <list-response
              ref="listResponse"
              :post="post"
              :post-schedule="postSchedule"
              :learner="learner"
              :learning-outcome="learningOutcome"
              :assessment-status="assessmentStatus"
              :active="showCollapse"
            />

            <!-- <response-submission
              v-if="latestSubmission"
              :post-response="latestSubmission"
            /> -->

            <div v-if="status.isNotSubmitted" class="card__response card-body">
              <div class="response__content">
                <div class="text-pre-wrap text__description pl-3">No file submitted</div>
              </div>
            </div>

            <!-- <div
              v-if="
                latestSubmission &&
                postResponsesAfterLatestSubmission &&
                postResponsesAfterLatestSubmission.length
              "
            >
              <response-feedback
                v-for="evaluation in postResponsesAfterLatestSubmission"
                :key="`feedback-${evaluation.id}`"
                :post-response="evaluation"
                :learning-outcome="learningOutcome"
                :additional-criterions="additionalCriteria"
                :is-evaluated-by-learning-outcome="
                  post.evaluate_learning_outcome
                "
                @editSuccess="editSuccess"
              />
            </div> -->

            <!-- <response-feedback
              v-if="latestSubmission && latestEvaluation"
              :post-response="latestEvaluation"
              :learning-outcome="learningOutcome"
              :additional-criterions="additionalCriteria"
            /> -->

            <div v-else>
              <b-button
                v-if="!showFeedbackSection"
                variant="success"
                class="mx-u5 my-u5"
                @click="showFeedbackSection = true"
              >
                Give Feedback
              </b-button>

              <div v-if="showFeedbackSection" class="card__review mt-3">
                <div class="text-dark header__title mx-4">Review</div>

                <div v-if="criteriaForReviews">
                  <div
                    v-for="(criteria, index) in criteriaForReviews"
                    :key="index"
                    :class="`post-${post.id}-criteria-${criteria.id}`"
                  >
                    <BaseLearningOutcomeAndCriterion
                      :index="getBaseLearningOutcomeAndCriterionIndex(criteria)"
                      :post="post"
                      head-title="Criteria"
                      :title="criteria.title"
                      :learning-outcome="criteria.learning_outcome"
                      :additional-criterion="criteria"
                      :description="criteria.description"
                      :pass-criterion="criteria.pass_criterion"
                      :not-yet-criterion="criteria.not_yet_criterion"
                      is-review
                      class="pt-3 pb-3 container__lo mx-4"
                      @onSelectedRadio="mapAdditionalEvaluation"
                    />
                    <div class="border-top border-medium" />
                  </div>
                </div>
                <div v-else class="border-top border-medium" />

                <!-- <div v-if="additionalCriteria.length > 0" class="mx-4">
                  <div class="font-weight-bold mb-1 header__title">
                    Additional assessment criteria
                  </div>

                  <BaseLearningOutcomeAndCriterion
                    v-for="(additionalCriterion, index) in additionalCriteria"
                    :id="additionalCriterion.id"
                    :key="index"
                    :index="`additionalCriterion-${learner.id}-${index}`"
                    :additional-criterion="additionalCriterion"
                    :show-title="false"
                    :description="additionalCriterion.description"
                    :pass-criterion="additionalCriterion.pass_criterion"
                    :not-yet-criterion="additionalCriterion.not_yet_criterion"
                    :pass="
                      latestEvaluation &&
                      latestEvaluation.assessment_evaluation &&
                      latestEvaluation.assessment_evaluation
                        .assessment_additional_evaluations.length
                        ? latestEvaluation.assessment_evaluation
                            .assessment_additional_evaluations[index].pass
                        : false
                    "
                    is-review
                    class="mb-4 container__assessment-criteria"
                    @onSelectedRadio="mapAdditionalEvaluation"
                  />
                </div> -->

                <!-- Feedback -->
                <b-row class="pt-2 mx-1">
                  <VueElementLoading :active="isSaving" />

                  <b-col class="pr-0">
                    <BaseInput
                      id="response-description"
                      v-model="description"
                      input-type="textarea"
                      label="Feedback"
                      rows="3"
                      placeholder="Enter your feedback."
                      :is-invalid="submitFail"
                      invalid-warning-text="The feedback message is required"
                      class="pt-3 container__submission-response"
                    />
                  </b-col>
                  <b-col cols="1" class="pt-5">
                    <BaseFilesUploadButton
                      ref="refBaseFileUpload"
                      class="mr-auto btn__attach-file"
                      @add-files="addFiles"
                    />

                    <base-s3-uploader
                      v-show="false"
                      id="input-attachments"
                      ref="attachmentUploader"
                      :reference-meta="{
                        ...referenceMeta,
                        field: 'attachments'
                      }"
                      :disabled="isSaving"
                      :is-public="false"
                    >
                    </base-s3-uploader>
                  </b-col>

                  <b-col v-if="attachments && attachments.length > 0" cols="12">
                    <BaseFilesList
                      :attachments="attachments"
                      enable-delete
                      class="pt-2 pb-4"
                      @delete-file="deleteFile"
                    />
                  </b-col>

                  <b-col cols="12" class="mb-3">
                    <div class="d-flex align-items-center">
                      <b-button
                        variant="success"
                        class="btn__submit-response"
                        :disabled="post.is_submission ? !disabledButtonSubmit : false"
                        @click="submit"
                      >
                        Submit
                      </b-button>
                      <!-- <b-button
                        v-if="status.isFeedback"
                        variant="link"
                        class="btn-link-dark"
                        @click="cancelEditFeedback"
                      >
                        Cancel
                      </b-button> -->
                    </div>
                  </b-col>
                </b-row>

                <!-- <div
                  v-if="(status.isFeedback || status.isPassed) && !editFeedback"
                  class="py-3 mx-4"
                >
                  <div class="d-flex justify-content-between">
                    <div class="font-weight-bold">Feedback</div>
                    <div
                      v-if="status.isFeedback"
                      class="icon-edit text-dark"
                      @click="onClickEditFeedback"
                    >
                      <font-awesome-icon
                        :icon="{ prefix: 'fas', iconName: 'edit' }"
                        class="font-size-sm"
                      />
                      Edit
                    </div>
                  </div>
                  <div class="mt-3 text-pre-wrap" v-html="description" />
                  <BaseFilesList :attachments="attachments" class="my-2" />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import {
  BaseUserProfile,
  BaseTagSubmissionStatus,
  BaseInput,
  BaseFilesList,
  BaseFilesUploadButton
} from '@/components/base-components';
import { BaseLearningOutcomeAndCriterion } from '@/components/base-components';
import BaseS3Uploader from '@/components/base-components/BaseS3Uploader';
import {
  LearningOutcome,
  Status,
  User,
  Post,
  Upload,
  AssessmentStatus,
  PostResponse,
  Criteria,
  PostSchedule,
  Learner
} from '@/models';
import { notificationMixin } from '@/mixins';
import ListResponse from './ListResponse';
// import ResponseSubmission from "./ResponseSubmission";
// import ResponseFeedback from "./ResponseFeedback";

export default {
  name: 'SubmissionAccordion',

  components: {
    BaseUserProfile,
    BaseTagSubmissionStatus,
    BaseLearningOutcomeAndCriterion,
    BaseFilesList,
    BaseFilesUploadButton,
    BaseInput,
    BaseS3Uploader,
    ListResponse
    // ResponseFeedback,
    // ResponseSubmission,
  },

  mixins: [notificationMixin],

  props: {
    post: {
      type: Post,
      required: true
    },

    postSchedule: {
      type: PostSchedule,
      required: true
    },
    // latestSubmissionId: {
    //   type: Number,
    //   default: null,
    // },
    // latestEvaluationId: {
    //   type: Number,
    //   default: null,
    // },
    // postResponses: {
    //   type: Array,
    //   default: () => [],
    // },
    // learner
    learner: {
      type: Learner,
      required: true
    },
    teacher: {
      type: User,
      required: true
    },
    learningUnitId: {
      type: Number,
      default: null
    },
    initialShowCollapse: {
      type: [Number, Boolean],
      default: true
    }
  },

  data() {
    return {
      description: '',
      attachments: [],
      fileIdsTodelete: [],
      submitFail: false,
      isSaving: false,
      showCollapse: this.initialShowCollapse,
      additionalEvaluation: {},
      formOldFeedback: {
        description: '',
        attachments: []
      },
      assessmentEvaluations: [],
      referenceMeta: {
        ref: 'post-response',
        refId: null
      },
      showFeedbackSection: false
    };
  },

  computed: {
    learningOutcome() {
      return LearningOutcome.query().where('learning_unit_id', this.learningUnitId).first();
    },

    assessmentStatus() {
      return AssessmentStatus.query()
        .with('status')
        .where('post_id', this.post.id)
        .where('user_id', this.learner.id)
        .first();
    },

    status() {
      return this.assessmentStatus ? this.assessmentStatus.status : Status.notSubmitted;
    },

    // additionalCriteria() {
    //   return AdditionalCriterion.query().where("post_id", this.post.id).get();
    // },

    // latestSubmission() {
    //   return this.postResponses.find(
    //     (postResponse) => postResponse.id == this.latestSubmissionId
    //   );
    // },

    // latestEvaluation() {
    //   return this.postResponses.find(
    //     (postResponse) => postResponse.id == this.latestEvaluationId
    //   );
    // },

    // otherPostResponses() {
    //   return this.postResponses.filter(({ id, created_at }) => {
    //     let filter =
    //       id !== this.latestSubmissionId &&
    //       created_at <= this.latestSubmission.created_at;

    //     // if (!this.status.isReviewPending) {
    //     //   filter = filter && id !== this.latestEvaluationId;
    //     // }

    //     return filter;
    //   });
    // },

    // postResponsesAfterLatestSubmission() {
    //   const { otherPostResponses = [] } = this;

    //   const postResponseIds = map(otherPostResponses, "id");

    //   return this.postResponses.filter(({ id, created_at }) => {
    //     let filter =
    //       id !== this.latestSubmissionId &&
    //       postResponseIds.indexOf(id) === -1 &&
    //       created_at > this.latestSubmission.created_at;

    //     // if (!this.status.isReviewPending) {
    //     //   filter = filter && id !== this.latestEvaluationId;
    //     // }

    //     return filter;
    //   });
    // },

    haveFilesToUpload() {
      return this.attachments.some((attachment) => !attachment.id);
    },

    learnerFullName() {
      return `${this.learner.firstname} ${this.learner.lastname}`;
    },

    criteriaForReviews() {
      return this.post && this.post.criterion_ids
        ? Criteria.query().whereId(this.post.criterion_ids).with('learning_outcome').get()
        : [];
    },

    disabledButtonSubmit() {
      return this.criteriaForReviews.length === this.assessmentEvaluations.length;
    }
  },

  watch: {
    description(newDesc) {
      if (newDesc) {
        newDesc = newDesc.trim();

        if (newDesc.length) {
          this.submitFail = false;
        }
      }
    },

    attachments(newAtt) {
      if (newAtt.length > 0) this.submitFail = false;
    }
  },

  methods: {
    async submit() {
      let { description = '' } = this;

      description = description.trim();

      if (!description.length && !this.attachments.length) {
        this.submitFail = true;
        return;
      }

      try {
        this.isSaving = true;

        // create post-response
        const body = {
          user: this.teacher.id,
          post: this.post.id,
          evaluated_user: this.learner.id,
          learning_unit: this.$route.params.learningUnitId,
          section: this.$route.params.sectionId,
          description,
          assessment_evaluations: this.assessmentEvaluations
        };

        const resultPostResponse = await PostResponse.api().responseByTeacher(body);

        const postResponseId = resultPostResponse.response.data.id;

        await resultPostResponse.save();

        this.$set(this.formOldFeedback, 'description', description);

        // upload file
        if (this.attachments.length) {
          await this.uploadFiles(postResponseId);
        }

        // update assessment status
        await AssessmentStatus.api().fetchPostStatus(this.learner.id, this.post.id);

        // this.$emit("submitSuccess", {
        //   statusId: latestAssessmentStatus.status_id,
        // });

        this.notiSuccess('response', 'sent');

        this.clear();

        this.$refs.listResponse.addNewResponseId(postResponseId);
      } catch (error) {
        this.$toast.error('Cannot submit feedback, please try again');

        throw new Error(error);
      } finally {
        this.isSaving = false;
        this.showFeedbackSection = false;
      }
    },

    async uploadFiles(id) {
      // let resultUpload = null;
      let uploadedAttachments = [];

      if (this.attachments.length > 0) {
        this.$set(this.referenceMeta, 'refId', id);

        this.$refs.attachmentUploader.addFiles(this.attachments);

        uploadedAttachments = await this.$refs.attachmentUploader.upload();

        // const uploadFileForm = new FormData();
        // uploadFileForm.append("ref", "post-response");
        // uploadFileForm.append("refId", id);
        // uploadFileForm.append("field", "attachments");
        // this.attachments.forEach((attachment) =>
        //   uploadFileForm.append("files", attachment)
        // );

        // resultUpload = await Upload.api().upload(uploadFileForm);
      }

      if (uploadedAttachments.length) {
        PostResponse.update({
          where: id,
          data: { attachments: uploadedAttachments }
        });

        this.$set(this.formOldFeedback, 'attachments', [...uploadedAttachments]);
      }
    },

    /**
     * @param {Array} ids list of id for files to delete
     */
    async removeFiles(ids) {
      for (const id of ids) {
        try {
          await Upload.api().deleteFile(id);
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
    },

    // async updateAssessmentStatus() {
    //   await AssessmentStatus.api().fetchPostStatus(
    //     this.learner.id,
    //     this.post.id
    //   );
    // },

    mapAdditionalEvaluation(criteria, pass_status) {
      if (this.assessmentEvaluations && this.assessmentEvaluations.length) {
        const index = this.assessmentEvaluations.findIndex(
          (assessmentEvaluation) => assessmentEvaluation.criterion.id == criteria.id
        );

        if (index == -1) {
          this.assessmentEvaluations.push({
            pass: pass_status,
            evaluated_user: this.learner.id,
            criterion: criteria
          });
        } else {
          this.assessmentEvaluations[index] = {
            pass: pass_status,
            evaluated_user: this.learner.id,
            criterion: criteria
          };
        }
      } else {
        this.assessmentEvaluations.push({
          pass: pass_status,
          evaluated_user: this.learner.id,
          criterion: criteria
        });
      }
    },

    addFiles(files) {
      this.attachments = this.attachments.concat(files);

      if (
        this.$refs.refBaseFileUpload &&
        this.$refs.refBaseFileUpload.$refs &&
        this.$refs.refBaseFileUpload.$refs.file
      ) {
        this.$refs.refBaseFileUpload.$refs.file.value = '';
      }
    },

    deleteFile(index) {
      this.attachments.splice(index, 1);
    },

    clear() {
      this.description = '';
      this.attachments = [];
      this.fileIdsTodelete = [];
      this.assessmentEvaluations = [];
      // this.criteriaForReviews.forEach((criteria) => {
      //   document.getElementById(
      //     `pass-criterion-radio-latest-submission_${this.latestSubmissionId}-criteria_${criteria.id}`
      //   ).checked = false;
      //   document.getElementById(
      //     `not-yet-criterion-radio-latest-submission_${this.latestSubmissionId}-criteria_${criteria.id}`
      //   ).checked = false;
      // });
    },

    getBaseLearningOutcomeAndCriterionIndex(criteria) {
      return `submission-criteria-${criteria.id}-${this.learner.id}`;
    }

    // getResponseComponent({
    //   assessment_submission = null,
    //   assessment_evaluation = null,
    // } = {}) {
    //   if (assessment_submission) {
    //     return ResponseSubmission;
    //   } else if (assessment_evaluation) {
    //     return ResponseFeedback;
    //   }
    // },
    // getResponseComponentProps(postResponse) {
    //   let additionalProps = {};
    //   if (postResponse?.assessment_evaluation) {
    //     const { learningOutcome } = this;
    //     additionalProps = {
    //       ...additionalProps,
    //       learningOutcome,
    //       additionalCriterions: AdditionalCriterion.query()
    //         .where("post", postResponse.post_id)
    //         .get(),
    //     };
    //   }
    //   additionalProps.isShowBoarder = false;
    //   return {
    //     postResponse,
    //     ...additionalProps,
    //   };
    // },
  }
};
</script>

<style lang="scss" scoped>
.icon-edit {
  cursor: pointer;
}
</style>
